<script>
  let { code = '', height = 48, variant = 'barcode' } = $props();

  function hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
  }

  function generateBars(str) {
    const seed = hashCode(str || 'RECEIPT');
    const bars = [];
    const totalBars = 60;
    let x = 0;

    for (let i = 0; i < totalBars; i++) {
      const pseudoRand = ((seed * (i + 1) * 7919 + i * 104729) % 1000) / 1000;
      const w = pseudoRand > 0.5 ? 2 : 1;
      const gap = pseudoRand > 0.7 ? 3 : pseudoRand > 0.3 ? 2 : 1;

      bars.push({ x, width: w });
      x += w + gap;
    }

    return { bars, totalWidth: x };
  }

  let barcodeData = $derived(generateBars(code));
</script>

<div class="receipt-barcode">
  {#if variant === 'barcode'}
    <svg
      class="receipt-barcode__svg"
      viewBox="0 0 {barcodeData.totalWidth} {height}"
      preserveAspectRatio="none"
      style:height="{height}px"
    >
      {#each barcodeData.bars as bar}
        <rect
          x={bar.x}
          y="0"
          width={bar.width}
          height={height}
          fill="var(--receipt-barcode-color)"
        />
      {/each}
    </svg>
  {:else}
    <hr class="receipt-barcode__minimal" style:margin-top="{height / 2}px" />
  {/if}

  {#if code}
    <span class="receipt-barcode__code">{code}</span>
  {/if}
</div>

<style>
  .receipt-barcode {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    width: calc(100% + 32px);
    margin-left: -16px;
    margin-right: -16px;
  }

  .receipt-barcode__svg {
    width: 100%;
    display: block;
  }

  .receipt-barcode__minimal {
    width: 100%;
    border: none;
    border-top: 1px solid var(--receipt-barcode-color);
    margin: 0;
  }

  .receipt-barcode__code {
    font-family: var(--font-mono);
    font-size: var(--receipt-size-meta);
    color: var(--receipt-text-muted);
    letter-spacing: var(--receipt-ls-code);
    text-align: center;
    user-select: none;
  }
</style>
